const getBaseUrl = () => {
    const { protocol, hostname, port } = location
    const portInfo = port ? `:${port}` : ''
    const baseUrl = `${protocol}//${hostname}${portInfo}/`
    return baseUrl
}

const baseUrl = import.meta.env.VITE_APP_BASE_URL || getBaseUrl()
const weixinH5Url = 'mobile/pages/electronic_notice/electronic_notice'
const config = {
    terminal: 1, //终端
    title: '后台管理系统', //网站默认标题
    version: '1.6.0', //版本号
    baseUrl, //请求接口域名
    urlPrefix: 'adminapi', //请求默认前缀
    timeout: 120 * 1000, //请求超时时长
    copyright: '上海优泽云软件有限公司', // 版权
    weixinH5Url
}

export default config
